import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { camdenNJConfig } from "./data";

export default function CamdenNJPage() {
  return <CityPageTemplate config={camdenNJConfig} />;
}